import { $ } from "@/common/Axios";

export default {
  /**
   * 自考视频章节
   */
  selfTaughtVideoChapter_batchAble: {
    /*
     * 批量启用禁用
     * ids 章节id (array query required)
     * ableStatus 启用状态：启用，禁用 (string query required)
     */
    put: (p, c) =>
      $.put("/api/cms/selftaught/selfTaughtVideoChapter/batchAble", p, c),
  },
  selfTaughtVideoChapter: {
    /*
     * 添加
     * chapter  ( query required)
     */
    post: (p, c) => $.post("/api/cms/selftaught/selfTaughtVideoChapter", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) =>
      $.delete("/api/cms/selftaught/selfTaughtVideoChapter", p, c),
  },
  selfTaughtVideoChapter_list: {
    /*
     * 列表
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtVideoChapter/list", p, c),
  },
  selfTaughtVideoChapter_listSimple: {
    /*
     * 简易列表
     * courseId 课程id (integer query required)
     * ableStatus 启用禁用 (string query )
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtVideoChapter/listSimple", p, c),
  },
  selfTaughtVideoChapter_listForClient: {
    /*
     * C端列表
     * courseId 课程Id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtVideoChapter/listForClient", p, c),
  },
  selfTaughtVideoChapter_batchRemove: {
    /*
     * 批量删除
     * ids 知识点id (array query required)
     */
    delete: (p, c) =>
      $.delete("/api/cms/selftaught/selfTaughtVideoChapter/batchRemove", p, c),
  },

  /**
   * 自考习题
   */
  selfTaughtSubject: {
    /*
     * 编辑
     * subject  ( query required)
     */
    put: (p, c) => $.put("/api/cms/selftaught/selfTaughtSubject", p, c),

    /*
     * 添加习题
     * subject  ( query required)
     */
    post: (p, c) => $.post("/api/cms/selftaught/selfTaughtSubject", p, c),
  },
  selfTaughtSubject_uploadByWord: {
    /*
     * 上传章节习题(Word)
     * chapterId 章节id (integer query required)
     * file  (string body required)
     */
    post: (p, c) =>
      $.post("/api/cms/selftaught/selfTaughtSubject/uploadByWord", p, c),
  },
  selfTaughtSubject_uploadByExcel: {
    /*
     * 上传章节习题(Excel)
     * chapterId 章节id (integer query required)
     * file  (string body required)
     */
    post: (p, c) =>
      $.post("/api/cms/selftaught/selfTaughtSubject/uploadByExcel", p, c),
  },
  selfTaughtSubject_list: {
    /*
     * 列表
     * chapterId 章节id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/selftaught/selfTaughtSubject/list", p, c),
  },
  selfTaughtSubject_listForDailyExercise: {
    /*
     * 每日一练习题
     * courseId 课程id (integer query required)
     * chapterIds 章节id (array query )
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtSubject/listForDailyExercise", p, c),
  },
  selfTaughtSubject_listContentType: {
    /*
     * 获取题型列表
     * courseId 课程id (integer query required)
     * chapterIds 章节id (array query )
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtSubject/listContentType", p, c),
  },
  selfTaughtSubject_listChapterSubjectForClient: {
    /*
     * C端章节习题列表
     * chapterId 章节id (integer query required)
     * exerciseId 练习id (integer query )
     */
    get: (p, c) =>
      $.get(
        "/api/cms/selftaught/selfTaughtSubject/listChapterSubjectForClient",
        p,
        c
      ),
  },
  selfTaughtSubject_listByCourseAndRemark: {
    /*
     * 根据课程和备注，获取自考章节习题列表
     * courseId 课程id (integer query required)
     * chapterIds 章节id (array query )
     * remark 备注 (string query )
     * contentType 内容类型 (string query )
     */
    get: (p, c) =>
      $.get(
        "/api/cms/selftaught/selfTaughtSubject/listByCourseAndRemark",
        p,
        c
      ),
  },
  selfTaughtSubject_info: {
    /*
     * 习题信息
     * type 类型：章节练习，模拟考试，历年真题，课后作业 (string query required)
     * id 习题id (integer query required)
     * exerciseId 练习id (integer query )
     */
    get: (p, c) => $.get("/api/cms/selftaught/selfTaughtSubject/info", p, c),
  },
  selfTaughtSubject_infoForClient: {
    /*
     * C端习题信息
     * type 类型：章节练习，模拟考试，历年真题，课后作业 (string query required)
     * id 习题id (integer query required)
     * exerciseId 练习id (integer query )
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtSubject/infoForClient", p, c),
  },
  selfTaughtSubject_export: {
    /*
     * 导出习题
     * chapterId 章节id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/selftaught/selfTaughtSubject/export", p, c),
  },
  selfTaughtSubject_exerciseInfo: {
    /*
     * 练习信息（全真模拟、课后作业）
     * belongId 归属id (integer query required)
     * type 类型：历年真题、课后作业 (string query required)
     * exerciseId 练习id (integer query )
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtSubject/exerciseInfo", p, c),
  },
  selfTaughtSubject_exerciseInfoForClient: {
    /*
     * C端练习信息
     * belongId 归属id (integer query required)
     * type 类型：模拟考试，历年真题，课后作业，随堂练习 (string query required)
     * exerciseId 练习id (integer query )
     */
    get: (p, c) =>
      $.get(
        "/api/cms/selftaught/selfTaughtSubject/exerciseInfoForClient",
        p,
        c
      ),
  },
  selfTaughtSubject_details: {
    /*
     * 习题详情
     * id 习题id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/selftaught/selfTaughtSubject/details", p, c),
  },

  /**
   * 自考学生观看章节视频记录
   */
  selfTaughtStudentVideo_progress: {
    /*
     * 修改进度，切换视频（新老视频都调用），返回，播放结束，暂停，HOME, 拖动 等情况调用
     * type 类型：直播课，精品课 (string query required)
     * contentId 内容id (integer query required)
     * progress 进度 (integer query required)
     * start 观看开始点（秒） (integer query required)
     * end 观看结束点（秒） (integer query required)
     */
    put: (p, c) =>
      $.put("/api/cms/selftaught/selfTaughtStudentVideo/progress", p, c),
  },
  selfTaughtStudentVideo_restore: {
    /*
     * 修复
     * id id (integer query )
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtStudentVideo/restore", p, c),
  },
  selfTaughtStudentVideo_listForVideo: {
    /*
     * 精品课观看记录列表
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtStudentVideo/listForVideo", p, c),
  },
  selfTaughtStudentVideo_listForLive: {
    /*
     * 直播课观看记录列表
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtStudentVideo/listForLive", p, c),
  },
  selfTaughtStudentVideo_history: {
    /*
     * 根据id获取观看历史记录
     * id 章节id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtStudentVideo/history", p, c),
  },
  selfTaughtStudentVideo_exportForVideo: {
    /*
     * 直播课观看记录列表导出
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtStudentVideo/exportForVideo", p, c),
  },
  selfTaughtStudentVideo_exportForLive: {
    /*
     * 直播课观看记录列表导出
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtStudentVideo/exportForLive", p, c),
  },

  /**
   * 自考学生练习
   */
  selfTaughtStudentExercise_restore: {
    /*
     * 修复
     */
    put: (p, c) =>
      $.put("/api/cms/selftaught/selfTaughtStudentExercise/restore", p, c),
  },
  selfTaughtStudentExercise_read: {
    /*
     * 阅卷
     * id 练习id (integer query required)
     * subjectIds 题目id (array query required)
     * scores 分数 (array query required)
     * level 等级 (string query required)
     */
    put: (p, c) =>
      $.put("/api/cms/selftaught/selfTaughtStudentExercise/read", p, c),
  },
  selfTaughtStudentExercise_hand: {
    /*
     * 交卷(返回练习id)
     * type 类型：章节练习，模拟练习，历年真题，课后作业 (string query required)
     * courseId 课程id (integer query required)
     * belongId 模拟练习 (integer query required)
     * exerciseTime 练习时间（秒） (integer query required)
     * subjectIds 题目id (array query required)
     * answers 答案 (array query required)
     */
    post: (p, c) =>
      $.post("/api/cms/selftaught/selfTaughtStudentExercise/hand", p, c),
  },
  selfTaughtStudentExercise_listHomework: {
    /*
     * 课后作业列表
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtStudentExercise/listHomework", p, c),
  },
  selfTaughtStudentExercise_listClassPractise: {
    /*
     * 随堂练习列表
     */
    get: (p, c) =>
      $.get(
        "/api/cms/selftaught/selfTaughtStudentExercise/listClassPractise",
        p,
        c
      ),
  },
  selfTaughtStudentExercise_listClassPractiseStatics: {
    /*
     * 随堂练习统计列表
     */
    get: (p, c) =>
      $.get(
        "/api/cms/selftaught/selfTaughtStudentExercise/listClassPractiseStatics",
        p,
        c
      ),
  },
  selfTaughtStudentExercise_listChapter: {
    /*
     * 章节练习列表
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtStudentExercise/listChapter", p, c),
  },
  selfTaughtStudentExercise_exportForHomework: {
    /*
     * 导出课后作业
     */
    get: (p, c) =>
      $.get(
        "/api/cms/selftaught/selfTaughtStudentExercise/exportForHomework",
        p,
        c
      ),
  },
  selfTaughtStudentExercise_exportForClassPractise: {
    /*
     * 导出随堂练习
     */
    get: (p, c) =>
      $.get(
        "/api/cms/selftaught/selfTaughtStudentExercise/exportForClassPractise",
        p,
        c
      ),
  },
  selfTaughtStudentExercise_exportForClassPractiseStatics: {
    /*
     * 导出随堂练习
     */
    get: (p, c) =>
      $.get(
        "/api/cms/selftaught/selfTaughtStudentExercise/exportForClassPractiseStatics",
        p,
        c
      ),
  },
  selfTaughtStudentExercise_exportChapter: {
    /*
     * 导出章节练习
     */
    get: (p, c) =>
      $.get(
        "/api/cms/selftaught/selfTaughtStudentExercise/exportChapter",
        p,
        c
      ),
  },

  /**
   * 自考课程
   */
  selfTaughtCourse_setPaperRule: {
    /*
     * 设置组卷规则
     * id 课程id (integer query required)
     * paperRule 配置的json字符串 (string query required)
     */
    put: (p, c) =>
      $.put("/api/cms/selftaught/selfTaughtCourse/setPaperRule", p, c),
  },
  selfTaughtCourse: {
    /*
     * 添加
     * course  ( query required)
     */
    post: (p, c) => $.post("/api/cms/selftaught/selfTaughtCourse", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/cms/selftaught/selfTaughtCourse", p, c),
  },
  selfTaughtCourse_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/cms/selftaught/selfTaughtCourse/list", p, c),
  },
  selfTaughtCourse_listSimple: {
    /*
     * 自考简易课程列表
     * ableStatus 启用禁用 (string query )
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtCourse/listSimple", p, c),
  },
  selfTaughtCourse_listForClient: {
    /*
     * 自考精品课C端口列表
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtCourse/listForClient", p, c),
  },
  selfTaughtCourse_getPaperRule: {
    /*
     * 获取组卷规则
     * id 课程id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtCourse/getPaperRule", p, c),
  },
  selfTaughtCourse_getIdByName: {
    /*
     * 根据名称获取id
     * name 名称 (string query required)
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtCourse/getIdByName", p, c),
  },
  selfTaughtCourse_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/cms/selftaught/selfTaughtCourse/export", p, c),
  },

  /**
   * 自考班级
   */
  selfTaughtClassRoom_setTerm: {
    /*
     * 设置考期
     * terms 考期 (array query required)
     */
    put: (p, c) =>
      $.put("/api/cms/selftaught/selfTaughtClassRoom/setTerm", p, c),
  },
  selfTaughtClassRoom_setCurrentTerm: {
    /*
     * 设置当前考期
     * term 考期 (string query required)
     */
    put: (p, c) =>
      $.put("/api/cms/selftaught/selfTaughtClassRoom/setCurrentTerm", p, c),
  },
  selfTaughtClassRoom: {
    /*
     * 添加
     * classRoom  ( query required)
     */
    post: (p, c) => $.post("/api/cms/selftaught/selfTaughtClassRoom", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/cms/selftaught/selfTaughtClassRoom", p, c),
  },
  selfTaughtClassRoom_upload: {
    /*
     * 导入
     * excelFile  (string body required)
     */
    post: (p, c) =>
      $.post("/api/cms/selftaught/selfTaughtClassRoom/upload", p, c),
  },
  selfTaughtClassRoom_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/cms/selftaught/selfTaughtClassRoom/list", p, c),
  },
  selfTaughtClassRoom_listTerm: {
    /*
     * 考期列表
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtClassRoom/listTerm", p, c),
  },
  selfTaughtClassRoom_listSimple: {
    /*
     * 简易列表
     * majorId 专业id (integer query )
     * term 考期 (string query )
     * courseId 课程id (integer query )
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtClassRoom/listSimple", p, c),
  },
  selfTaughtClassRoom_listSimpleByTeacher: {
    /*
     * 简易列表(讲师所负责班级)
     * majorId 专业id (integer query )
     * term 考期 (string query )
     * courseId 课程id (integer query )
     */
    get: (p, c) =>
      $.get(
        "/api/cms/selftaught/selfTaughtClassRoom/listSimpleByTeacher",
        p,
        c
      ),
  },
  selfTaughtClassRoom_getCurrentTerm: {
    /*
     * 当前考期
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtClassRoom/getCurrentTerm", p, c),
  },
  selfTaughtClassRoom_export: {
    /*
     * 导出
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtClassRoom/export", p, c),
  },

  /**
   * 自考章节练习计划
   */
  selfTaughtChapterPlan: {
    /*
     * 编辑
     * plan  ( query required)
     */
    put: (p, c) => $.put("/api/cms/selftaught/selfTaughtChapterPlan", p, c),

    /*
     * 添加
     * plan  ( query required)
     */
    post: (p, c) => $.post("/api/cms/selftaught/selfTaughtChapterPlan", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) =>
      $.delete("/api/cms/selftaught/selfTaughtChapterPlan", p, c),
  },
  selfTaughtChapterPlan_upload: {
    /*
     * 导入
     * excelFile  (string body required)
     */
    post: (p, c) =>
      $.post("/api/cms/selftaught/selfTaughtChapterPlan/upload", p, c),
  },
  selfTaughtChapterPlan_list: {
    /*
     * 列表
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtChapterPlan/list", p, c),
  },
  selfTaughtChapterPlan_export: {
    /*
     * 导出
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtChapterPlan/export", p, c),
  },
  selfTaughtChapterPlan_exportUnfinishedStudentByPlan: {
    /*
     * 根据计划导出未完成学员
     * id 计划id (integer query required)
     */
    get: (p, c) =>
      $.get(
        "/api/cms/selftaught/selfTaughtChapterPlan/exportUnfinishedStudentByPlan",
        p,
        c
      ),
  },
  selfTaughtChapterPlan_exportUnfinishedStudentByHeaderTeacher: {
    /*
     * 根据班主任导出未完成学员
     */
    get: (p, c) =>
      $.get(
        "/api/cms/selftaught/selfTaughtChapterPlan/exportUnfinishedStudentByHeaderTeacher",
        p,
        c
      ),
  },

  /**
   * 错题集
   */
  selfTaughtWrongSubject_batchAdd: {
    /*
     * 批量添加错题（每日一练）
     * subjectIds 习题id (array query required)
     * answers 答案 (array query required)
     */
    post: (p, c) =>
      $.post("/api/cms/selftaught/selfTaughtWrongSubject/batchAdd", p, c),
  },
  selfTaughtWrongSubject_listSubject: {
    /*
     * 自考错题集列表（习题）
     * chapterId 章节id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtWrongSubject/listSubject", p, c),
  },
  selfTaughtWrongSubject_listChapter: {
    /*
     * 自考错题集列表（章节）
     * courseId 课程id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtWrongSubject/listChapter", p, c),
  },
  selfTaughtWrongSubject_details: {
    /*
     * 自考错题集详情
     * subjectId 习题id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtWrongSubject/details", p, c),
  },
  selfTaughtWrongSubject: {
    /*
     * 移除
     * subjectId 习题id (integer query required)
     */
    delete: (p, c) =>
      $.delete("/api/cms/selftaught/selfTaughtWrongSubject", p, c),
  },

  /**
   * 自考习题章节
   */
  selfTaughtSubjectChapter: {
    /*
     * 添加
     * chapter  ( query required)
     */
    post: (p, c) =>
      $.post("/api/cms/selftaught/selfTaughtSubjectChapter", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) =>
      $.delete("/api/cms/selftaught/selfTaughtSubjectChapter", p, c),
  },
  selfTaughtSubjectChapter_list: {
    /*
     * 列表
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtSubjectChapter/list", p, c),
  },
  selfTaughtSubjectChapter_listSimple: {
    /*
     * 简易列表
     * courseId 课程id (integer query required)
     * ableStatus 启用禁用 (string query )
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtSubjectChapter/listSimple", p, c),
  },
  selfTaughtSubjectChapter_listForClient: {
    /*
     * C端列表
     * courseId 课程id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtSubjectChapter/listForClient", p, c),
  },

  /**
   * 自考学习资料
   */
  selfTaughtStudyMaterials: {
    /*
     * 添加
     * materials  ( query required)
     */
    post: (p, c) =>
      $.post("/api/cms/selftaught/selfTaughtStudyMaterials", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) =>
      $.delete("/api/cms/selftaught/selfTaughtStudyMaterials", p, c),
  },
  selfTaughtStudyMaterials_list: {
    /*
     * 列表
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtStudyMaterials/list", p, c),
  },
  selfTaughtStudyMaterials_listLabel: {
    /*
     * 标签列表
     * courseId 课程id (integer query )
     * ableStatus 启用状态 (string query )
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtStudyMaterials/listLabel", p, c),
  },
  selfTaughtStudyMaterials_listForClient: {
    /*
     * C端列表
     * courseId 课程id (integer query )
     * label 标签 (string query )
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtStudyMaterials/listForClient", p, c),
  },

  /**
   * 自考学生班级
   */
  selfTaughtStudentClassRoom_uploadRemoveOrCreate: {
    /*
     * 导入删除或者添加
     * type 类型：添加、删除 (string query required)
     * classId 班级id (integer query required)
     * file  (string body required)
     */
    post: (p, c) =>
      $.post(
        "/api/cms/selftaught/selfTaughtStudentClassRoom/uploadRemoveOrCreate",
        p,
        c
      ),
  },
  selfTaughtStudentClassRoom_uploadAssignClass: {
    /*
     * 导入分班
     * assignType 类型：覆盖、增量 (string query required)
     * term 考期 (string query )
     * excelFile  (string body required)
     */
    post: (p, c) =>
      $.post(
        "/api/cms/selftaught/selfTaughtStudentClassRoom/uploadAssignClass",
        p,
        c
      ),
  },
  selfTaughtStudentClassRoom_batchAssignClass: {
    /*
     * 批量分配班级
     * assignType 类型：覆盖、增量 (string query required)
     * schoolRollIds 学生id (array query required)
     * classIds 班级id (array query required)
     * term 考期 (string query )
     */
    post: (p, c) =>
      $.post(
        "/api/cms/selftaught/selfTaughtStudentClassRoom/batchAssignClass",
        p,
        c
      ),
  },
  selfTaughtStudentClassRoom_assignClass: {
    /*
     * 单个分配班级（只有覆盖模式）
     * schoolRollId 学生id (integer query required)
     * classIds 班级id (array query required)
     * term 考期 (string query )
     */
    post: (p, c) =>
      $.post(
        "/api/cms/selftaught/selfTaughtStudentClassRoom/assignClass",
        p,
        c
      ),
  },
  selfTaughtStudentClassRoom_listSimpleByStudent: {
    /*
     * 根据学生和考期获取班级情况
     * schoolRollId 合同id (integer query )
     * term 考期 (string query )
     */
    get: (p, c) =>
      $.get(
        "/api/cms/selftaught/selfTaughtStudentClassRoom/listSimpleByStudent",
        p,
        c
      ),
  },
  selfTaughtStudentClassRoom_listClassIdsByStudent: {
    /*
     * 根据学生和考期获取班级id
     * schoolRollId 合同id (integer query )
     * term 考期 (string query )
     */
    get: (p, c) =>
      $.get(
        "/api/cms/selftaught/selfTaughtStudentClassRoom/listClassIdsByStudent",
        p,
        c
      ),
  },
  selfTaughtStudentClassRoom_exportByClass: {
    /*
     * 根据班级导出学生名单
     * classId 班级id (integer query required)
     */
    get: (p, c) =>
      $.get(
        "/api/cms/selftaught/selfTaughtStudentClassRoom/exportByClass",
        p,
        c
      ),
  },
  selfTaughtStudentClassRoom_exportAssignClass: {
    /*
     * 导出
     * term 考期 (string query )
     */
    get: (p, c) =>
      $.get(
        "/api/cms/selftaught/selfTaughtStudentClassRoom/exportAssignClass",
        p,
        c
      ),
  },

  /**
   * 自考计划
   */
  selfTaughtPlan: {
    /*
     * 添加
     * plan  ( query required)
     */
    post: (p, c) => $.post("/api/cms/selftaught/selfTaughtPlan", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/cms/selftaught/selfTaughtPlan", p, c),
  },
  selfTaughtPlan_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/cms/selftaught/selfTaughtPlan/list", p, c),
  },
  selfTaughtPlan_listPlan: {
    /*
     * 计划名称列表
     */
    get: (p, c) => $.get("/api/cms/selftaught/selfTaughtPlan/listPlan", p, c),
  },

  /**
   * 自考试卷
   */
  selfTaughtPaper: {
    /*
     * 添加
     * paper  ( query required)
     */
    post: (p, c) => $.post("/api/cms/selftaught/selfTaughtPaper", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/cms/selftaught/selfTaughtPaper", p, c),
  },
  selfTaughtPaper_createSimulate: {
    /*
     * 创建模拟练习
     * courseId 课程id (integer query required)
     */
    post: (p, c) =>
      $.post("/api/cms/selftaught/selfTaughtPaper/createSimulate", p, c),
  },
  selfTaughtPaper_listType: {
    /*
     * 试卷类型
     */
    get: (p, c) => $.get("/api/cms/selftaught/selfTaughtPaper/listType", p, c),
  },
  selfTaughtPaper_listSimulateForClient: {
    /*
     * C端模拟练习列表
     * courseId 课程id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtPaper/listSimulateForClient", p, c),
  },
  selfTaughtPaper_listSimple: {
    /*
     * 简易列表
     * courseId 课程id (integer query required)
     * type 类型 (string query required)
     * term 考期 (string query required)
     * classRoomId 班级id (integer query )
     * planId 班级id (integer query )
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtPaper/listSimple", p, c),
  },
  selfTaughtPaper_listReal: {
    /*
     * 自考历年真题列表
     */
    get: (p, c) => $.get("/api/cms/selftaught/selfTaughtPaper/listReal", p, c),
  },
  selfTaughtPaper_listRealForClient: {
    /*
     * C端历年真题列表
     * courseId 课程id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtPaper/listRealForClient", p, c),
  },
  selfTaughtPaper_listHomework: {
    /*
     * 家庭作业列表
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtPaper/listHomework", p, c),
  },
  selfTaughtPaper_listClassPractise: {
    /*
     * 随堂练习列表
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtPaper/listClassPractise", p, c),
  },
  selfTaughtPaper_listClassPractiseForClient: {
    /*
     * C端随堂练习列表
     * courseId 课程id (integer query required)
     * isToday 是否当天 (boolean query )
     */
    get: (p, c) =>
      $.get(
        "/api/cms/selftaught/selfTaughtPaper/listClassPractiseForClient",
        p,
        c
      ),
  },
  selfTaughtPaper_content: {
    /*
     * 习题内容
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/selftaught/selfTaughtPaper/content", p, c),
  },

  /**
   * 自考直播章节
   */
  selfTaughtLiveChapter: {
    /*
     * 添加
     * chapter  ( query required)
     */
    post: (p, c) => $.post("/api/cms/selftaught/selfTaughtLiveChapter", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) =>
      $.delete("/api/cms/selftaught/selfTaughtLiveChapter", p, c),
  },
  selfTaughtLiveChapter_list: {
    /*
     * 列表
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtLiveChapter/list", p, c),
  },
  selfTaughtLiveChapter_listSimple: {
    /*
     * 简易列表
     * courseId 课程id (integer query required)
     * ableStatus 启用禁用 (string query )
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtLiveChapter/listSimple", p, c),
  },
  selfTaughtLiveChapter_listForClient: {
    /*
     * C端列表
     * homeShow 是否主页展示 (string query )
     * playBack 是否回放 0 不是回放,1 是回放, 不传则返回所有 (integer query )
     * courseId 课程id (integer query )
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtLiveChapter/listForClient", p, c),
  },

  /**
   * 自考收藏
   */
  selfTaughtCollect: {
    /*
     * 收藏|取消收藏
     * type 类型：精品课，习题 (string query required)
     * contentId 内容id (integer query required)
     */
    post: (p, c) => $.post("/api/cms/selftaught/selfTaughtCollect", p, c),
  },
  selfTaughtCollect_listSubjectForSubject: {
    /*
     * 自考习题收藏列表（习题）
     * chapterId 章节id (integer query required)
     */
    get: (p, c) =>
      $.get(
        "/api/cms/selftaught/selfTaughtCollect/listSubjectForSubject",
        p,
        c
      ),
  },
  selfTaughtCollect_listChapterForSubject: {
    /*
     * 自考习题收藏列表（章节）
     * courseId 课程id (integer query required)
     */
    get: (p, c) =>
      $.get(
        "/api/cms/selftaught/selfTaughtCollect/listChapterForSubject",
        p,
        c
      ),
  },
  selfTaughtCollect_detailsForSubject: {
    /*
     * 自考习题收藏详情
     * subjectId 习题id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtCollect/detailsForSubject", p, c),
  },

  /**
   * 测试答题分析
   */
  selfTaughtAnswerAnalyse_listStudent: {
    /*
     * 学生列表
     * id id (integer query required)
     * type 类型：正确，错误 (string query required)
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtAnswerAnalyse/listStudent", p, c),
  },
  selfTaughtAnswerAnalyse_listClassPractise: {
    /*
     * 随堂练习列表
     */
    get: (p, c) =>
      $.get(
        "/api/cms/selftaught/selfTaughtAnswerAnalyse/listClassPractise",
        p,
        c
      ),
  },
  selfTaughtAnswerAnalyse_getByPaperAndSubject: {
    /*
     * 根据试卷和习题id查询分析
     * paperId 试卷id (integer query required)
     * subjectId 习题id (integer query required)
     */
    get: (p, c) =>
      $.get(
        "/api/cms/selftaught/selfTaughtAnswerAnalyse/getByPaperAndSubject",
        p,
        c
      ),
  },
  selfTaughtAnswerAnalyse_exportClassPractise: {
    /*
     * 导出随堂练习列表
     */
    get: (p, c) =>
      $.get(
        "/api/cms/selftaught/selfTaughtAnswerAnalyse/exportClassPractise",
        p,
        c
      ),
  },
};
